import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { fmtDateTimeFull } from "@extensions/utils";
import { tokenVidsLabel } from "@extensions/enums";

const MessageDialogsItem = ({ dialog, selected, onClick, onEdit }) => {
  const truncateText = (text) => {
    if (!text) return "";
    const firstLine = text.split('\n')[0];
    return firstLine.length > 50 ? firstLine.substring(0, 50) + "..." : firstLine;
  };

  return (
    <div
      className={`dialog-item ${selected ? 'selected' : ''}`}
      onClick={onClick}
      style={{
        padding: '12px',
        borderBottom: '1px solid #f0f0f0',
        cursor: 'pointer',
        backgroundColor: selected ? '#e6f7ff' : 'white',
      }}
    >
      {(dialog.tokenName || tokenVidsLabel(dialog.vid)) && (
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
          {[dialog.tokenName, tokenVidsLabel(dialog.vid)].filter(Boolean).join(" · ")}
        </div>
      )}
      <div style={{ fontWeight: 'bold', marginBottom: '4px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {dialog.name && dialog.name.trim() ? dialog.name : (dialog.phone || `Диалог #${dialog.id}`)}
        </span>
        {onEdit && (
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={(e) => { e.stopPropagation(); onEdit(dialog.id); }}
            title="Изменить"
          />
        )}
      </div>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
        {dialog.lastUpdated ? fmtDateTimeFull(dialog.lastUpdated) : fmtDateTimeFull(dialog.createdOn)}
      </div>
      <div style={{ fontSize: '13px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {truncateText(dialog.lastMessageBody) || "Нет сообщений"}
      </div>
    </div>
  );
};

export default MessageDialogsItem;
